export default function StatsGrid({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
      {stats.map(s => (
        <div key={s.label} className="bg-[#122036] border border-[#1c2a3d] rounded-lg p-4" data-testid={`stat-${s.label.toLowerCase()}`}>
          <div className="flex items-center gap-2 mb-2">
            <s.icon className="w-4 h-4 text-[#d4af37]" />
            <span className="text-[#a3b1c6] text-xs uppercase tracking-wider">{s.label}</span>
          </div>
          <p className="text-2xl font-medium text-[#fdfbf7]">{s.count}</p>
        </div>
      ))}
    </div>
  );
}
